import { Box, Button, Container, Typography } from "@mui/material";
import React, { useEffect } from "react";
import Sidebar from "./Admin/Sidebar";
import { Outlet, useNavigate } from "react-router-dom";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import { useDispatch, useSelector } from "react-redux";
import { clearUser } from "../redux/userSlice";

const AdminDashboard = () => {
  const user = useSelector((state) => state.user.user)
  const navigate = useNavigate();
  useEffect(() => {
    if(!user || !JSON.parse(localStorage.getItem('user'))){
      navigate('/')
    }

    if(user.userRole.includes("USER")){
      navigate("/dashboard")
    }
  }, [])
  const dispatch = useDispatch();

  const handleLogout = () => {
    dispatch(clearUser());
    navigate('/')
  };
  return (
    <Box sx={{ background: "#fff", maxHeight: "100vh", overflow: 'hidden', display: {xs: 'none', sm: 'block'} }}>
      <Container
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          py: 2,
        }}
      >
        <Typography variant="h4">Admin Dashboard</Typography>
        <Button sx={{ color: "#fff", padding: "10px 20px" }} onClick={handleLogout}>
          <LogoutOutlinedIcon sx={{ pr: 1 }} />
          Logout
        </Button>
      </Container>
      <Box display={"flex"}>
        <Sidebar />
        <Box
          sx={{
            flex: 1,
            overflowY: "scroll",
            overflowX: 'hidden',
            height: "calc(100vh - 77px)", // Adjust for header height
            px: 5
          }}
        >
          <Outlet />
        </Box>
      </Box>
    </Box>
  );
};

export default AdminDashboard;
